import { z } from 'zod';
import { Sha256HashSchema, SourceIdSchema, SourceItemIdSchema } from './common.js';

export const SourceItemImportStatusSchema = z.enum([
  'pending',
  'processing',
  'completed',
  'failed',
  'skipped',
]);
export type SourceItemImportStatus = z.infer<typeof SourceItemImportStatusSchema>;

/**
 * Representerer ett originalelement fra en kilde (e-post, SMS, fil, vedlegg).
 * Bindet til kilden via sourceId; hash beviser at elementet er uendret.
 */
export const SourceItemSchema = z.object({
  id: SourceItemIdSchema,
  sourceId: SourceIdSchema,
  /** Ekstern id fra kildesystemet, f.eks. Message-ID eller UID */
  externalId: z.string().optional(),
  /** Opprinnelig filsti eller URL i kilden */
  originalPath: z.string().optional(),
  hash: Sha256HashSchema,
  /** Rå metadata fra kilden som JSON */
  rawMetadata: z.record(z.string(), z.unknown()),
  importStatus: SourceItemImportStatusSchema,
});

export type SourceItem = z.infer<typeof SourceItemSchema>;
